import React from "react";
import { ButtonSize } from "../Button/Button.styles";

import {
  TextColorVariant,
  TypeFormButtonContainer,
  TypeFormButtonVariant,
} from "./TypeFormButton.styles";

export interface TypeFormButtonProps {
  label: string;
  variant?: TypeFormButtonVariant;
  textColor?: TextColorVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  disabled?: boolean;
}

const BUTTON_VARIANT_LEGACY_MAPPING = {
  // New
  primary: "primary",
  secondaryDark: "secondaryDark",
  secondaryLight: "secondaryLight",
  outline: "outline",
  // Legacy
  dark: "secondaryLight",
  secondary: "secondaryLight",
};

const TypeFormButton: React.FC<TypeFormButtonProps> = ({
  label,
  variant = "primary",
  textColor,
  size = "medium",
  fullWidth,
  disabled,
}) => (
  <TypeFormButtonContainer
    id="WccWfRLY"
    $variant={BUTTON_VARIANT_LEGACY_MAPPING[variant] as TypeFormButtonVariant}
    $textColor={textColor}
    $size={size}
    $fullWidth={fullWidth}
    $disabled={disabled}
  >
    {label}
  </TypeFormButtonContainer>
);

export default TypeFormButton;
